import {Payment} from "./payment";

export class Invoice {
  id: string;
  due: number;
  paid: number;
  customerId: number;
  sessionId: number;
  paymentList: Payment[];
}



// WEBPACK FOOTER //
// ./src/app/invoice.ts